import { render, staticRenderFns } from "./NetaHomeContentComponent.vue?vue&type=template&id=774c4592&"
import script from "./NetaHomeContentComponent.vue?vue&type=script&lang=js&"
export * from "./NetaHomeContentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports